import { render, staticRenderFns } from "./entityDialog.vue?vue&type=template&id=530ea916&scoped=true&"
import script from "./entityDialog.vue?vue&type=script&lang=js&"
export * from "./entityDialog.vue?vue&type=script&lang=js&"
import style0 from "./entityDialog.vue?vue&type=style&index=0&id=530ea916&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530ea916",
  null
  
)

export default component.exports